/**
 * A list of brands that we support on MWP.
 *
 * Shared to avoid other packages from maintaining separate lists.
 */
export enum Brand {
  SNAP = 'snap',
  SNAPCHAT = 'snapchat',
  SPECTACLES = 'spectacles',
}

export const brandNames: Record<Brand, string> = {
  [Brand.SNAP]: 'Snap',
  [Brand.SNAPCHAT]: 'Snapchat',
  [Brand.SPECTACLES]: 'Spectacles',
};

export const allBrands = [Brand.SNAP, Brand.SNAPCHAT, Brand.SPECTACLES] as const;
